import React from 'react'
import Books from '../../../assets/pngwing.com.png'
import { Button, styled, Typography } from '@mui/material'
import ErrorLayout from '../errorLayout'
import { useKeycloak } from '@react-keycloak/web'

const ErroCode = styled(Typography)(() => ({
  fontSize: '1rem',
  fontWeight: 'bolder',
  textAlign: 'center'
}))
const ErroTitle = styled(Typography)(() => ({
  fontSize: '3.5rem',
  lineHeight: '3.5rem',
  textAlign: 'center'
}))

const StyledBooks = styled('img')(() => ({
  height: '80vh',
  position: 'absolute',
  right: '-10vw',
  bottom: '-10vh',
  zIndex: '-1'
}))

const ErrorDescription = styled(Typography)(() => ({
  background: 'transparent',
  marginTop: '1rem',
  fontSize: '1.5rem',
  textAlign: 'center'
}))

const InternalError = () => {
  const { keycloak } = useKeycloak()

  return (
    <ErrorLayout>
      <StyledBooks src={Books} />
      <ErroTitle>Erro Interno</ErroTitle>
      <ErroCode>Código do erro: 500</ErroCode>
      <ErrorDescription>Entre em contato com o suporte!</ErrorDescription>
      <Button
        onClick={() => {
          keycloak.logout()
          keycloak.authenticated = false
        }}
        variant="contained"
        color="leitura"
        sx={{ margin: 'auto', mt: { xs: 6, md: 3 } }}
      >
        Voltar para o login
      </Button>
    </ErrorLayout>
  )
}

export default InternalError
